module.exports = __webpack_public_path__ + "img/8.6a2c2a2d.png";